import React, { Component } from "react";
import { Image } from "semantic-ui-react";
import _ from "lodash";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import getReportType from "./ReportType";
import Check from "../../assets/images/check.gif";
import HourGlass from "../../assets/images/hourglass.png";
import "../../assets/styles/bootstrap-table-extra.css";

class OfflineReportTable extends Component {
  componentDidMount() {
    this.loadData(this.props);
  }

  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  redirectToLink = (offlineCrimCode) => {
    localStorage.offlineResultId = offlineCrimCode;
    localStorage.offlinePickedUser = this.props.pickedUser;
    this.props.history.push("/offline/criminalsearch");
  };

  reportLink = (cell, row) => (
    <span
      role="button"
      tabIndex={0}
      className={"url-link-activity"}
      onClick={() =>
        this.redirectToLink(row.actId, row.actReportId, row.activityDescription)
      }
    >
      {row.activityDescription}
    </span>
  );

  reportFormat = (cell, row) => (
    <span
      role="button"
      tabIndex={0}
      className={"url-link-activity"}
      onClick={() => this.redirectToLink(row.crimCode)}
    >
      {row.reqStatus[0] === "R" ? (
        <Image src={Check} inline className={"icon-align-middle"} />
      ) : (
        <Image src={HourGlass} inline className={"icon-align-middle"} />
      )}
      {row.name}
    </span>
  );

  loadData = (props) => {
    const rows = [];
    if (props.recs !== undefined) {
      _.forEach(props.recs, (element) => {
        const cols = {
          crimCode: _.get(element, "crimCode[0]", ""),
          name: `${_.get(element, "nameFirst[0]", "")} ${_.get(
            element,
            "nameLast[0]"
          )}`,
          requestCode: _.get(element, "requestCode[0]", ""),
          reqStatus: _.get(element, "reqStatus[0]", ""),
          reportType: getReportType(_.get(element, "requestCode[0]", "")),
          ssn: _.get(element, "ssn[0]", ""),
          dateBirth: _.get(element, "dateBirth[0]", ""),
          jurisdiction: `${_.get(element, "reqDistrictName[0]", "")} ${_.get(
            element,
            "reqCountyName[0]",
            ""
          )} ${_.get(element, "reqStateCode[0]", "")}`,
          date:
            _.get(element, "reqStatus[0]", "") === "r"
              ? _.get(element, "timeUpdated[0]", "")
              : _.get(element, "timeCreated[0]", ""),
        };
        rows.push(cols);
      });
    }

    const columns = [
      {
        dataField: "reqStatus",
        text: "Subject",
        formatter: this.reportFormat,
        width: "15%",
        sort: true,
      },
      {
        dataField: "ssn",
        text: "SSN",
        width: "30%",
        sort: true,
      },
      {
        dataField: "dateBirth",
        text: "DOB",
        width: "10%",
        sort: true,
      },
      {
        dataField: "reportType",
        text: "Report",
        width: "10%",
        sort: true,
      },
      {
        dataField: "jurisdiction",
        text: "Jurisdiction",
        width: "15%",
        sort: true,
      },
      {
        dataField: "date",
        text: "Date/Time",
        width: "15%",
        sort: true,
      },
    ];
    if (this.state === undefined) {
      this.state = { rows, columns };
    } else {
      this.setState({ rows, columns });
    }
  };

  render() {
    if (this.state !== null && this.state.columns.length > 0) {
      return (
        <BootstrapTable
          data={this.state.rows}
          keyField={"crimCode"}
          columns={this.state.columns}
          pagination={paginationFactory()}
          striped
          hover
        />
      );
    }
    return null;
  }
}

export default OfflineReportTable;



// WEBPACK FOOTER //
// ./src/components/myaccount/OfflineReportTable.js